export const GET_USERS = "users/GET_USERS";
export const SET_USERS = "users/SET_USERS";
export const UPDATE_USERS = "users/UPDATE_USERS";
export const DELETE_USERS = "users/DELETE_USERS";